export interface Language {
  code: string;
  label: string;
  nativeName: string;
  dir: "ltr" | "rtl";
}

const ALL_LANGUAGES: Language[] = [
  { code: "en", label: "EN", nativeName: "English",  dir: "ltr" },
  { code: "zh", label: "ZH", nativeName: "中文",     dir: "ltr" },
  { code: "es", label: "ES", nativeName: "Español",  dir: "ltr" },
  { code: "ar", label: "AR", nativeName: "عربي",     dir: "rtl" },
  { code: "hi", label: "HI", nativeName: "हिन्दी",   dir: "ltr" },
];

const enabledCodes = (process.env.REACT_APP_ENABLED_LANGUAGES || "en")
  .split(",")
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

if (!enabledCodes.includes("en")) enabledCodes.unshift("en");

export const ENABLED_LANGUAGES: Language[] = ALL_LANGUAGES.filter((l) =>
  enabledCodes.includes(l.code)
);
